var React = require('react');

function Command (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Industrial Command Ship"),React.createElement("path",{"id":"path1191-9-1-7","className":"cls-1","d":"M114,47.34,97.33,30.67H30.67L14,47.34v58.33l25-25H89l25,25Z","key":2})]);
}

Command.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Command;

Command.default = Command;
